module.exports = __webpack_public_path__ + "static/img/app1.0ab7176b.jpg";